/**
 * Check if a partner exists on a user.
 *
 * @param {object} user
 * @param {string} partner
 *
 * @returns {boolean}
 */
export default (user, partner) => {
    if (!user || !user.authenticated) {
        return false;
    }
    return !!user.partners.some((userPartner) => userPartner.id === partner);
};
